import React, { useEffect, useState } from 'react';
import Styled from './styled';
import { MessageParticipantRole } from '@amzn/ring-cs-chatbot-service-model';

const DURATION = 500;

export type IndicatorProps = {
    /** Which type of Loading Indicator color (defaults to CUSTOM_BOT) */
    indicator?: MessageParticipantRole;
    /** Desired width of indicator */
    width?: number;
};

export type LoadingProps = {
    /** Desired width/height of loader */
    width?: string;
    height?: string;
};

/**
 * LoadingIndicator & TypingIndicator components run on a loop
 * 
 * @param props - The properties to configure the
 * LoadingIndicator & TypingIndicator component.
 * @returns The rendered components.
 */
export const TypingIndicator: React.FC<IndicatorProps> = ({
    indicator = MessageParticipantRole.CUSTOM_BOT,
    width = 140,
}: IndicatorProps): JSX.Element => {
    const [variant, setVariant] = useState(1);
    const boundedWidth = Math.max(12, Math.min(200, width));

    useEffect(() => {
        const interval = setInterval(() => {
            setVariant((prev) => (prev + 1) % 4);
        }, DURATION);

        return () => clearInterval(interval);
    }, []);

    return (
        <Styled.IndicatorWrapper>
            <Styled.LoadingDot
                variant={variant}
                indicator={indicator}
                duration={DURATION}
                width={boundedWidth}
            />
        </Styled.IndicatorWrapper>
    );
};

export const LoadingIndicator: React.FC<LoadingProps> = ({
    width = '24px',
    height = '24px',
}: LoadingProps): JSX.Element => {
    return (
        <Styled.LoadingWrapper>
            <Styled.Loader
                width={width}
                height={height}
            />
        </Styled.LoadingWrapper>
    );
};
